
import { defineComponent } from 'vue'
export default defineComponent({
  props: {
    title: {
      type: String,
      require: false,
      default: ''
    },
    hasLine: {
      type: Boolean,
      require: false,
      default: false
    }
  }
})
